<template>
  <div class="container">
    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab title="General">I'm the first fading tab</b-tab>
        <b-tab title="Edit profile">
          I'm the second tab
          <b-card>I'm the card in tab</b-card>
        </b-tab>
        <b-tab title="Premium Plan" disabled>Sibzamini!</b-tab>
        <b-tab title="Info">I'm the last tab</b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Sidebar from '../../components/dashboard/sidebar';

export default {
  name: 'product-on-mitra',
  components: {
    Sidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/public/dashboard/product-on-mitra.vue